const DCF_ACTIONS = {
  ADD_CARD: 'ADD_CARD',
  CANCEL: 'CANCEL',
  CHANGE_CARD: 'CHANGE_CARD',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR',
  SERVER_ERROR: 'SERVER_ERROR',
  SERVICE_ERROR: 'SERVICE_ERROR',
  SWITCH_CONSUMER: 'SWITCH_CONSUMER',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR'
};

export default DCF_ACTIONS;
